<template>
    <modal @close="$emit('close')" width="95%" max-width="500px">
        <div slot="title">{{$t('title')}}</div>
        <div slot="footer" class="p-2 text-right">
            <button class="btn btn-sm btn-primary" @click="upload">{{$t('report')}}</button>
        </div>
        <div class="modal-content-wrapper container py-2">
            <div class="row">
                <div class="col-12">
                    <label class="field-label">{{$t('account_last_five_digits')}}</label>
                    <div class="field-value"><input type="text" class="form-control" minlength="5" maxlength="5" :placeholder="$t('account_last_five_digits_placeholder')" v-model="accountLastFiveDigits" /></div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label class="field-label">{{$t('transferred_at')}}</label>
                    <div class="field-value"><input type="datetime-local" class="form-control" required v-model="transferredAt" /></div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label class="field-label">{{$t('transferred_image')}}</label>
                    <div class="field-value">
                        <single-file-select :maxImageLength="1024" :mimeTypes="['image/png', 'image/jpeg', 'image']" @image-selected="onImageSelected">
                            <div slot-scope="props">
                                <button class="btn btn-sm btn-secondary" @click="props.openFileSelect()">{{$t('select_image')}}</button>
                            </div>
                        </single-file-select>
                    </div>
                    <img v-if="selectedImage" :src="selectedImage.data" width="200" />
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import SingleFileSelect from '../common/SingleFileSelect.vue'
import api from '../../mixins/api';
import promptConfirm from '../../mixins/prompt-confirm';

export default {
    components: { SingleFileSelect },
    mixins: [ api,promptConfirm ],
    props: {
        payment: { type: Object, required: true}
    },
    data() {
        return {
            accountLastFiveDigits: null,
            transferredAt: null,
            selectedImage: null
        }
    },
    methods: {
        onImageSelected(imageInfo) {
            this.selectedImage = imageInfo;
        },
        dataURItoBlob(dataURI) {
            if (!dataURI) {
                return null;
            }
            var byteString;
            if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(dataURI.split(',')[1]);
            } else {
                byteString = unescape(dataURI.split(',')[1]);
            }

            // separate out the mime component
            var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ia], { type:mimeString });
        },
        upload() {
            if (!this.accountLastFiveDigits || this.accountLastFiveDigits.length != 5) {
                this.promptAlert(this.$t('please_enter_5_digits_account'));
                return;
            }
            if (!this.transferredAt) {
                this.promptAlert(this.$t('please_select_transfer_time'));
                return;
            }
            const closeLoading = this.promptLoading();
            this.reportAtmPayment(this.payment.booking_id, this.payment.id, this.accountLastFiveDigits, this.transferredAt, this.dataURItoBlob(this.selectedImage?.data), (response, error) => {
                closeLoading();
                if (!error) {
                    this.$emit('reported', response.data);
                    this.promptAlert(this.$t('atm_payment_reported'), () => {}, 'success');
                } else {
                    this.promptAlert(this.$t('fail_to_upload'));
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    .modal-content-wrapper {
        padding-bottom: 0px !important;
    }
    .field-label {
        font-size: 0.8em;
        color: #90A4AE;
        word-break: break-all;
        width: 100%;
    }

    .field-value {
        word-break: break-all;
        font-size: 1.1em;
        color: #31393C;
        margin-bottom: 14px;
    }
</style>

<i18n>
    {
        "zh": {
            "title": "回報轉帳完成",
            "account_last_five_digits": "帳號後五碼",
            "account_last_five_digits_placeholder": "用以匯款的銀行帳號後五碼",
            "transferred_at": "轉帳時間",
            "transferred_image": "轉帳紀錄照片",
            "select_image": "點此選取轉帳紀錄照片",
            "report": "回報",
            "fail_to_upload": "抱歉，無法完成回報",
            "atm_payment_reported": "回報完成，謝謝您",
            "please_enter_5_digits_account": "請輸入您的匯款帳號後五碼",
            "please_select_transfer_time": "請選擇轉帳時間"
        },
        "en": {
            "title": "Report Bank Transfer",
            "account_last_five_digits": "Last 5 digits of your account",
            "account_last_five_digits_placeholder": "Enter last 5 digits of your bank account",
            "transferred_at": "Transferred At",
            "transferred_image": "Photo of transaction",
            "select_image": "Select Image",
            "report": "Report",
            "fail_to_upload": "Sorry, fail to report at this moment",
            "atm_payment_reported": "Reported, thank you!",
            "please_enter_5_digits_account": "Please enter last 5 digits of your bank account used to transfer",
            "please_select_transfer_time": "Please select transfer time"
        }
    }
</i18n>